import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { Typography } from "@material-ui/core";
import Utility from "../../../utility/index";

function MainListItems(props) {
  const onMenuItemClick = (path) => {
    Utility.navigateToPath(path);
  };
  return (
    <div>
      <ListItem
        button
        onClick={() => onMenuItemClick("/home/dashboard")}
        id="ListItem_Hover"
      >
        <ListItemIcon>
          <img
            src="/images/Dashboard.svg"
            alt=""
            className={
              window.location.pathname.includes("dashboard")
                ? "dash-Selected"
                : ""
            }
             onClick={()=>props?.setOpen(false)}
          />
        </ListItemIcon>
        <ListItemText
          primary={
            <div
              className={
                window.location.pathname.includes("dashboard")
                  ? "dashboardEffect"
                  : "dash-NonSelected"
              }
              onClick={()=>props?.setOpen(false)}
            >
              Dashboard
            </div>
          }
        />
      </ListItem>
      <ListItem button onClick={() => onMenuItemClick("/home/users")}>
        <ListItemIcon>
          <img
            src="/images/user_icon.svg"
            alt=""
            className={
              window.location.pathname.includes("users") ? "dash-Selected selected-user" : ""
            }
            onClick={()=>props?.setOpen(false)}
          />
        </ListItemIcon>
        <ListItemText
          primary={
            <div
              className={
                window.location.pathname.includes("users")
                  ? "dashboardEffect"
                  : "dash-NonSelected"
              }
              onClick={()=>props?.setOpen(false)}
            >
              User
            </div>
          }
        />
      </ListItem>
      {/* <ListItem button>
        <ListItemIcon>
          <img src="/images/promotion.svg" alt=""   onClick={()=>props?.setOpen(false)}/>
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography variant="h6" style={{ color: "white", fontSize:"14px" }}>
              Campaign
            </Typography>
          }
        />
      </ListItem> */}
      <ListItem button onClick={() => onMenuItemClick("/home/terms")}>
        <ListItemIcon>
          <img
            src="/images/setting.svg"
            alt=""
            className={
              window.location.pathname.includes("terms") ? "dash-Selected selected-user" : ""
            }
            onClick={()=>props?.setOpen(false)}
          />
        </ListItemIcon>
        <ListItemText
          primary={
            <div
              className={
                window.location.pathname.includes("terms")
                  ? "dashboardEffectTerms"
                  : "dash-NonSelected"
              }
              onClick={()=>props?.setOpen(false)}
            >
              Setting
            </div>
          }
        />
      </ListItem>
    </div>
  );
}

export default MainListItems;
